/**
 * History Header Component
 * Displays the page title and subtitle
 */

import React from 'react';
import {
  typographyColors,
  typography,
  fontPrimary,
  spacing,
} from '@/design-system/utils';

interface HistoryHeaderProps {
  title?: string;
  subtitle?: string;
}

export const HistoryHeader: React.FC<HistoryHeaderProps> = ({
  title = 'Chat History',
  subtitle = 'All your recent chats',
}) => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: spacing[1],
        alignItems: 'center',
        textAlign: 'center',
      }}
    >
      <h1
        style={{
          fontFamily: fontPrimary,
          fontSize: typography.size['2xl'],
          fontStyle: 'normal',
          fontWeight: typography.weight.semibold,
          color: typographyColors.text,
          margin: 0,
          lineHeight: 'normal',
          textAlign: 'center',
        }}
      >
        {title}
      </h1>
      <p
        style={{
          fontFamily: fontPrimary,
          fontSize: typography.size.base,
          fontStyle: 'normal',
          fontWeight: typography.weight.regular,
          color: typographyColors.secondary,
          margin: 0,
          lineHeight: 'normal',
        }}
      >
        {subtitle}
      </p>
    </div>
  );
};
